// JobContext.js
import { createContext, useContext, useState, useEffect } from 'react';

const JobContext = createContext();

export const JobProvider = ({ children }) => {
    const [showAddJob, setShowAddJob] = useState(false);
    const [jobToEdit, setJobToEdit] = useState(null);
    const [editedJob, setEditedJob] = useState(null);
    const [updatedJob, setUpdatedJob] = useState(null);

    const [requests, setRequests] = useState([]);

    const openEditJob = (job) => {
        setJobToEdit(job);   // set job = edit mode
        setShowAddJob(true);
    };

    const notifyJobUpdated = (job) => {
        setUpdatedJob(job);
    };

    return (
        <JobContext.Provider value={{
            showAddJob, setShowAddJob, jobToEdit, setJobToEdit, openEditJob, editedJob, setEditedJob, requests,
            setRequests, notifyJobUpdated,
            updatedJob,
            setUpdatedJob
        }}>
            {children}
        </JobContext.Provider>
    );
};

export const useJobContext = () => useContext(JobContext);